
import SocialLogin from '../../content/SocialLogin';
import MenuPlans from './MenuPlans';


const Finaloffer = () => {
  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', fontFamily: 'Inter, Segoe UI, Tahoma, Geneva, Verdana, sans-serif', display: 'flex', flexDirection: 'column' }}>
      <MenuPlans />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{
          background: '#fff',
          borderRadius: 28,
          boxShadow: '0 12px 40px rgba(22,199,158,0.13), 0 2px 8px rgba(102,126,234,0.10)',
          padding: '64px 48px 56px 48px',
          maxWidth: 600,
          minHeight: 650,
          width: '100%',
          margin: '56px 0',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <h1 style={{ fontSize: '2.2rem', fontWeight: 900, color: '#16c79e', marginBottom: 10, textAlign: 'center', letterSpacing: '-1px', display: 'flex', alignItems: 'center', gap: 10 }}>
            <span role="img" aria-label="confetti">🎉</span> Plata confirmată!
          </h1>
          <p style={{ color: '#374151', fontSize: '1.18rem', marginBottom: 18, textAlign: 'center', fontWeight: 500 }}>
            Contul tău a fost creat automat pe baza emailului introdus la facturare.
          </p>
          <div style={{
            background: 'linear-gradient(90deg, #16c79e 0%, #764ba2 100%)',
            color: '#fff',
            borderRadius: 12,
            padding: '8px 20px',
            fontWeight: 600,
            fontSize: 15,
            marginBottom: 18,
            boxShadow: '0 2px 8px rgba(22,199,158,0.08)'
          }}>
            Alege cum vrei să-ți activezi contul:
          </div>
          <div style={{ width: '100%', marginBottom: 18, display: 'flex', flexDirection: 'column', gap: 22, alignItems: 'center', justifyContent: 'center' }}>
            <SocialLogin />
          </div>
          <p style={{ fontSize: 13, color: '#6b7280', marginTop: 8, textAlign: 'center', lineHeight: 1.6 }}>
            Dacă ai deja cont cu acest email, vei fi conectat automat.<br />
            Dacă nu, vei putea seta o parolă sau folosi Google/LinkedIn pentru acces.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Finaloffer;